export default {
  help: {
    help: 'Help',
    loginIssue: 'Login issues',
    loginIssueDescription: 'Having trouble getting into your account?',
    frequentlyQuestion: 'Frequently asked questions',
    frequentlyQuestionDescription: 'Read our FAQs for immediate answers.',
    contactUs: 'Contact us',
    contactUsDescription: 'Find out how to get in touch with us.',
  },
  login: {
    title: 'Login',
    textField: {
      email: 'Email address or phone number',
      password: 'Password',
    },
    error: {
      dialog: {
        title: 'Error',
        message: "Whoops! Our wires got crossed, but we're working on it now.",
      },
    },
    buttons: {
      help: 'Help',
      forgotPassword: 'Forgot password',
      faceIDButton: 'Face ID',
      touchIDButton: 'Biometrics',
      logIn: 'Log in',
      signUp: 'Sign up',
      dismiss: 'Dismiss',
      update: 'Update',
      ok: 'OK',
    },
  },
  resetPassword: {
    checkEmail: {
      title: 'Forgot password',
      header: 'Check your email',
      description: 'We sent an email with a reset link to ',
      toast: 'New link on its way!',
      buttons: {
        resend: 'Resend link ',
        mail: 'Go to email',
      },
    },
    confirmIdentity: {
      title: 'Forgot password',
      header: 'Confirm your identity',
      email: 'email',
      phone: 'phone',
      description:
        'It’s for your security. Let us know if you prefer an email or text.',
      section: {
        email: 'Email',
        message: 'Text message',
      },
      buttons: {
        title: 'I can’t access my account’s phone number or email',
      },
    },
    createPassword: {
      title: 'Forgot password',
      header: 'Create a new password',
      textField: {
        newPassword: 'New password',
        confirmPassword: 'Confirm new password',
        changePassword: 'Change Password',
      },
      buttons: {
        next: 'Next',
        ok: 'OK',
      },
      texts: {
        error: 'Error',
      },
      error: {
        passwordNotMatch: 'Password doesn’t match',
      },
    },
    emailReview: {
      title: 'Forgot password',
      header: 'Let’s find your account',
      description:
        'Enter the email you used to sign up so we can find your account.',
      system: 'system',
      textField: {
        email: 'Email address',
      },
      buttons: {
        next: 'Next',
      },
    },
    information: {
      tryAgain: 'Try Again',
      accountNotFoundScreen: {
        header: 'We can’t find your account',
        body: 'Make sure you entered the email address you used to sign up with Varo.',
      },
      linkExpired: {
        header: 'Your link has expired',
        body: 'Go back to the forgot password start so we can send you a new one.',
      },
      errors: {
        header: 'Something went wrong',
        body: 'There was an error validating your code. You can try again later.',
      },
      reachedCodeRequestLimit: {
        header: "We couldn't verify you",
        body: 'You have exceeded the number of verification code requests. Please try again later in 10 minutes.',
      },
      genericErrors: {
        header: 'Something went wrong',
        body: 'You can try again later.',
      },
      buttons: {
        resetPassword: 'Reset password',
        login: 'Go to login',
        tryAgain: 'Try again',
        done: 'Done',
      },
    },
    success: {
      title: 'Password Updated',
      description: 'You successfully reset your password.',
      buttons: {
        done: 'Done',
      },
    },
  },
  shared: {
    checkEmail: {
      alert: {
        ios: {
          title: 'Mail access',
          message: 'No mail app is installed or accessible.',
        },
        android: {
          title: 'Gmail access',
          message: 'Gmail app is not installed or accessible.',
        },
      },
    },
  },
  welcome: {
    title: 'GET AHEAD WITH A FREE BANK ACCOUNT',
    subtitle:
      'Plus get paid early, borrow cash when you need it, build credit, and save. Quals apply.',
    buttons: {
      logIn: 'Log in',
      signUp: 'Sign up',
      done: 'Done',
    },
    disclosure: 'Optional services have fees. ',
    disclosureLink: 'Disclosures',
    disclosureText: {
      one: 'Fees apply to out-of-network withdrawals & cash deposits. A full list of Varo fees can be found ',
      two: '\nWe give access to direct deposits from employer & government payers on the day we receive them, typically up to 2 days earlier than your scheduled pay date.',
      three:
        '\nA variety of factors impact your credit. Building your credit is a process and may take time, but the Varo Believe Card may be able to help when you consistently make on-time payments.',
      hyperlink: 'here.',
    },
  },
  verifyAddressChange: {
    addressScreenTitle: {
      home: 'Home Address',
      mailing: 'Mailing Address',
    },
  },
};
